import styled, { css } from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import BaseSheet, { TSheetProps } from './Sheet';

const getStylesByPosition = (props: TSheetProps) => {
    const radius = props.$radius || 32;
    const position = props.position || 'bottom';

    const map = {
        'right': `${radius}px 0 0 ${radius}px`,
        'left': `0 ${radius}px ${radius}px 0`,
        'top': `0 0 ${radius}px ${radius}px`,
        'bottom': `${radius}px ${radius}px 0 0`,
    };

    const paddingMap = { 'top': 'bottom', 'right': 'left', 'bottom': 'top', 'left': 'right' };

    const defaultPadding = 20;

    return css`
        border-radius: ${map[position]};
        padding-${paddingMap[position]}: ${defaultPadding}px;
    `;
};

const Sheet = styled(BaseSheet)`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    background-color: ${({ $bgColor = COLORS.BgSurface }) => $bgColor};
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border: 1px solid ${COLORS.Outline_Light};

    overflow-y: hidden;

    transition: .5s;
    transform: translateY(0);

    width: 100%;
    max-height: calc(100vh - 80px);
    height: auto;

    box-sizing: border-box;

    ${getStylesByPosition};

    ${Button} {
        position: absolute;
        top: 16px;
        right: 16px;
    }
`;

export default Sheet;
